/**
 * 获取url后参数
 */
export const GetRequest = () => {
    let url = location.search; //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
        }
    }
    return theRequest;
};

//获取字符串中倒数第二的指定字符串的索引
export function getSecondLastIndex(str, substr) {
    let lastIndex = str.lastIndexOf(substr);
    if (lastIndex === -1) {
        return -1; // 子字符串不存在
    }
    let secondLastIndex = str.lastIndexOf(substr, lastIndex - 1);
    return secondLastIndex;
}

export function debounce(func, delay) {
    let timer;
    return function(...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    }
}


// 获取文件类型
export function generateTableIcon ({ evidenceName, folderStatus, dataBusinessType }) {
    // 权利卫士的svg图标
    if (folderStatus === 1) {
        return 'folder'
    } else if (dataBusinessType === 22) {
        // 邮件认证专门的svg图标
        return 'email'
    } else if (dataBusinessType === 1 || dataBusinessType === 2) {
        // 电脑端-网页取证 电脑端-网页取证增强版
        return 'jpg'
    } else if (dataBusinessType === 4 || dataBusinessType === 5 || dataBusinessType === 6 || dataBusinessType === 7 || dataBusinessType === 8) {
        // 电脑端-录屏取证 电脑端-境外取证 电脑端-音视频自动取证 电脑端-直播自动取证 微信公众号取证
        return 'video'
    } else if (dataBusinessType === 9 || dataBusinessType === 11) {
        // 手机端-录像取证 手机端--录屏取证
        return 'video'
    } else if (dataBusinessType === 10) {
        // 手机端--录音取证
        return 'audio'
    } else if (dataBusinessType === 12 || dataBusinessType === 13) {
        // 手机端--网页取证 手机端--拍照取证
        return 'jpg'
    } else {
        // 其他情况
        let strArray = evidenceName.split('.')
        // 存在.
        if (strArray.length > 1) {
            let type = strArray[strArray.length - 1]
            type = type.toLowerCase()
            // 办公软件类型
            if (type === 'doc' || type === 'docx') {
                return 'word'
            } else if (type === 'xls' || type === 'xlsx') {
                return 'excel'
            } else if (type === 'ppt' || type === 'pptx') {
                return 'ppt'
            } else if (type === 'pdf') {
                return 'pdf'
            } else if (type === 'jpg' || type === 'jpeg') {
                // 图片类型
                return 'jpg'
            } else if (type === 'png') {
                // 图片类型
                return 'png'
            } else if (type === 'gif') {
                // 图片类型
                return 'picture'
            } else if (type === 'mp3' || type === 'wav' || type === 'm4a') {
                // 音频类型
                return 'audio'
            } else if (type === 'mp4' || type === 'avi' || type === 'rmvb' || type === 'mov' || type === 'webm') {
                // 视频类型
                return 'video'
            } else if (type === 'zip') {
                // 压缩包类型
                return 'zip'
            } else if (type === 'rar') {
                return 'rar'
            } else if (type === 'psd') {
                return 'ps'
            } else if (type === 'ai') {
                return 'ai'
            } else if (type === 'key') {
                return 'ketnoy'
            } else {
                // 其他类型
                return 'other'
            }
        } else {
            return 'other'
        }
    }
}

export function videoToType(value) {
  let format={
    'mp4':'video/mp4',
    'webm':'video/webm',
    'ogv':'video/ogg',
    'ogg':'video/ogg',
    'm3u8':'application/x-mpegURL',
    'mpd':'application/dash+xml',
    'flv':'video/x-flv',
    'mov':'video/quicktime',
    //音频
    'mp3':'audio/mp3',
    'wav':'audio/wav',
    'aac':'audio/aac',
    'm4a':'audio/mp4',
  }
  return format[value]
}